import { DonutChartLoopComponent } from '../charts/donut-chart-loop-component'

export class AFCompareSovByLocation extends DonutChartLoopComponent {
 static config = {
  selector: 'afCompareSovByLocation',
  controller: AFCompareSovByLocation,
  bindings: DonutChartLoopComponent.config.bindings,
  template: DonutChartLoopComponent.config.template,
 }

 setProperties() {
  this.seriesColors = this.colorUtils.compareMetaColors(this.visualizationMetaData)
  this.csvHeaders = ['Category', 'Count', 'Country Code'];
//   this.transformationProfiles = [{ key: 'ALL', type: TRANSFORM_POSITIVE_NEGATIVE_WORDS }]
 }
}
